{
  "actions": "Dejanja",
  "actionsAvailable": "Na voljo so dejanja.",
  "clearSelection": "Počisti izbor",
  "selected": "{count, plural, =0 {Nič izbranih} other {# izbranih}}",
  "selectedAll": "Vsi izbrani"
}
